<template>
  <div class="store_wrapper">
    <div>
      <!-- <pre>{{ allData }}</pre> -->
      <div class="row">
        <!-- <div class="main_border mt-3" style="height: 300px">
          <GmapMap
            style="width: 100%; height: 100%"
            :zoom="10"
            :center="{ lat: +data.lat, lng: +data.lng }"
            ref="map"
          >
            <GmapMarker
              :position="{ lat: +data.lat, lng: +data.lng }"
              :draggable="false"
            />
          </GmapMap>
        </div> -->
        <h3 class="main_color mt-4">بيانات الفرع</h3>
        <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-user"
              title="اسم الفرع"
              :number="branchData.full_name"
            ></stats-card>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-phone"
              title="الهاتف"
              :number="branchData.phone_complete_form"
            ></stats-card>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-store"
              title="مفعل ؟"
              :number="branchData.is_active ? 'مفعل' : 'غير مغعل'"
            ></stats-card>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-store"
              title="مفعل من الادراة ؟"
              :number="branchData.is_admin_accept ? 'مفعل' : 'غير مغعل'"
            ></stats-card>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-store"
              title="محظور ؟"
              :number="branchData.is_admin_accept ? 'محظور' : 'غير محظور'"
            ></stats-card>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-money"
              title="المحفظة"
              :number="branchData.wallet ? branchData.wallet : '0'"
            ></stats-card>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4" v-if="branchData.city">
          <div class="wrraper">
            <stats-card
              icon="fal fa-city"
              title="المدينة"
              :number="branchData.city?.name"
            ></stats-card>
          </div>
        </div>

        <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-hand-holding-usd"
              :title="$t('forms.labels.purchase_settlement_method')"
              :number="
                (branchData.purchase_settlement_method ||
                  branchData.store?.purchase_settlement_method) ===
                'CASH_ON_PICKUP'
                  ? $t('forms.labels.purchase_settlement_cash_on_pickup')
                  : $t('forms.labels.purchase_settlement_credit')
              "
            ></stats-card>
          </div>
        </div>

        <!-- Covered Districts -->
        <div
          class="col-12"
          v-if="
            (branchData.districts && branchData.districts.length) ||
            (branchData.store?.districts && branchData.store?.districts.length)
          "
        >
          <div class="wrraper p-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold">
                <i class="far fa-draw-polygon text-primary ml-1"></i>
                {{ $t("forms.labels.districts") }} (نطاق التغطية)
              </span>
              <span class="badge badge-primary badge-pill">
                {{
                  (branchData.districts || branchData.store?.districts || [])
                    .length
                }}
              </span>
            </div>
            <div class="d-flex flex-wrap gap-2">
              <span
                v-for="dist in branchData.districts ||
                branchData.store?.districts ||
                []"
                :key="dist.id"
                class="badge badge-light border px-2 py-1"
                style="font-size: 13px"
              >
                <i class="fas fa-map-marker-alt text-danger mr-1"></i>
                {{ dist.name || (dist.ar ? dist.ar.name : dist.name) }}
              </span>
            </div>
          </div>
        </div>
        <!-- <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-city"
              title="السجل التجاري"
              :number="data.store.commercial_registration_number"
            ></stats-card>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-phone"
              title="هاتف المحاسب"
              :number="data.store.accountant_phone"
            ></stats-card>
          </div>
        </div>
        <div
          class="col-sm-6 col-md-6 col-lg-4"
          v-if="data.store.place_category"
        >
          <div class="wrraper">
            <stats-card
              icon="fal fa-store"
              title="تصنيف المتجر"
              :number="data.store.place_category.ar.name"
            ></stats-card>
          </div>
        </div>
        <div
          class="col-sm-6 col-md-6 col-lg-4"
          v-if="data.store.restaurant_specialty"
        >
          <div class="wrraper">
            <stats-card
              icon="fal fa-store"
              title="تصنيف المطعم"
              :number="data.store.restaurant_specialty.name"
            ></stats-card>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-store"
              title="اخر تسجيل دخول"
              :number="data.last_login_at ? data.last_login_at : 'لم يتم'"
            ></stats-card>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-store"
              title="عدد مرات تسجيل الدخول"
              :number="data.login_count"
            ></stats-card>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-store"
              title="متصل ؟"
              :number="data.is_online ? 'متصل' : 'غير متصل'"
            ></stats-card>
          </div>
        </div>

        <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-id-badge"
              title="اجمالي التوصيل المجاني"
              :number="data.wallet_statics.free_offers_total"
            ></stats-card>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-id-badge"
              title="اجمالي خصومات الشركة"
              :number="data.wallet_statics.decrements"
            ></stats-card>
          </div>
        </div> -->
        <!-- <div class="col-sm-6 col-md-6 col-lg-4">
            <div class="wrraper">
              <stats-card
                icon="fal fa-id-badge"
                title="اجمالي عروض التوصيل"
                :number="data.wallet_statics.bonus"
              ></stats-card>
            </div>
          </div> -->
        <!-- <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-id-badge"
              title="قيمة الطلبات المستحقة من المتجر"
              :number="data.wallet_statics.money_needed.toFixed(2)"
            ></stats-card>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-id-badge"
              title="اجمالي مستحقات الشركة"
              :number="data.wallet_statics.app_amount_store.toFixed(2)"
            ></stats-card>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-id-badge"
              title="اجمالي قيمة التوصيل"
              :number="data.wallet_statics.orders_delivery_total.toFixed(2)"
            ></stats-card>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-id-badge"
              title="اجمالي الطلبات"
              :number="data.wallet_statics.orders_total.toFixed(2)"
            ></stats-card>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-id-badge"
              title="اجمالي المنتجات"
              :number="data.wallet_statics.orders_sub_total.toFixed(2)"
            ></stats-card>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4">
          <div class="wrraper">
            <stats-card
              icon="fal fa-id-badge"
              title="متوسط تقيمات المتجر"
              :number="data.wallet_statics.rate_avg"
            ></stats-card>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data", "id"],
  emits: ["showBranch"],
  data() {
    return {
      allData: null,
    };
  },
  computed: {
    branchData() {
      return this.data || this.allData || {};
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    this.allData = this.data;
  },
};
</script>
<style lang="scss" scoped>
.store_wrapper {
  padding: 1rem;
  @include mainShadow;
  border-radius: 15px;
}
</style>
